import React from "react";
import { ToastHandler } from "./ToastHandler";

export const ToastProvider: React.FC<{ element: React.ReactElement }> = ({ element }) => {
  return typeof window !== "undefined" ? <ToastHandler>{element}</ToastHandler> : <>{element}</>;
};

export default ToastProvider;
